import PublicApi from "../../../../shared/enums/PublicApi";
import { RegFormListApiResponseType } from "./type";
import { useGetApiData } from "shared/datalayer";

/**
 * @name useGetFormsList
 * @description This is used to get list of available form for an specific Reg
 * @param regId
 * @param sponsorOrgId
 */
export function useGetFormsList(regId: string, sponsorOrgId?: string, divisionId?: string) {
  return useGetApiData<RegFormListApiResponseType>(
    PublicApi.REGISTRATION_FORMS_LIST,
    { params: { registrationId: regId, sponsorOrganizationId: sponsorOrgId, divisionId } },
    { enabled: Boolean(regId) }
  );
}
